//This is an example file, not meant to be used.
export default {
    "general.hello-world": "こんにちは、世界",
    "general.app.name": "彼はモニトー"
}